import styled from 'styled-components'

export interface MenuSearchProps {
  openMenuState: boolean
}

export interface LabelSelectedProps {
  minWidthLabel?: string
}

export const ContainerResearch = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: auto;
  padding-left: 16px;
  box-sizing: border-box;
  border: 1px solid ${props => props.theme.colors.colordfe3e8};
  border-radius: 4px;
  position: relative;

  div {
    box-shadow: none !important;
  }
`
export const LabelSelected = styled.div<LabelSelectedProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  width: auto;
  min-width: ${({ minWidthLabel }) => minWidthLabel ?? '128px'};
  box-sizing: border-box;
  white-space: nowrap;

  font-size: 13px;
  cursor: pointer !important;
`
export const ArrowContainerSearch = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 100%;
  width: 32px;
  min-width: 32px;
  box-sizing: border-box;
  padding: 4px 0px;
`
export const ArrowDivider = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  height: 100%;
  width: 100%;
  border-right: 1px solid #ccc;
`
export const Arrow = styled.div<MenuSearchProps>`
  width: 6px;
  height: 6px;
  border-right: 1px solid black;
  border-bottom: 1px solid black;
  transform: ${({ openMenuState }) => (openMenuState ? 'rotate(225deg)' : 'rotate(45deg)')};
  transition: all 0.1s;
`

export const IconResearch = styled.div<{ disabled: boolean }>`
  box-sizing: border-box;
  width: 40px;
  cursor: pointer;
  background-color: ${props => props.theme.colors.color122d52};
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;

  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    color: ${({ disabled, theme }) => (disabled ? theme.colors.color6b7786 : 'white')};
    height: 14px;
    width: 14px;
  }
`

export const MenuSearchContainer = styled.div<MenuSearchProps>`
  position: absolute;
  width: auto;
  min-width: 144px;
  height: auto;
  top: 46px;
  left: -16px;
  background-color: white;
  border-left: 1px solid ${props => props.theme.colors.colordfe3e8};
  border-right: 1px solid ${props => props.theme.colors.colordfe3e8};
  border-bottom: 1px solid ${props => props.theme.colors.colordfe3e8};
  padding: 0px 14.7px;
  box-sizing: border-box;
  opacity: ${({ openMenuState }) => (openMenuState ? 1 : 0)};
  pointer-events: ${({ openMenuState }) => (openMenuState ? 'all' : 'none')};
  transition: 0.2s;
  z-index: 10;
`
export const MenuSearchItem = styled.div<LabelSelectedProps>`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 35px;
  width: 100%;
  cursor: pointer;
  z-index: 10;
`
export const InputSearch = styled.input`
  display: flex;
  width: 90%;
  margin-left: 1px;
  min-height: 30px;
  box-sizing: border-box;
  padding: 5px 8px;
  border-radius: 2;
  outline: none;
`
